<template>
  <div class="preview">
    <div class="scrtc_main">
      <div
        v-if="isLoading"
        v-bind:class="{ scrtc_loading_hide:!isLoading, scrtc_loading_show:isLoading  }"
      >
        <div class="loading_text">{{ txtLoading }}</div>
      </div>
      <iframe
        id="scrtc_iframe"
        v-bind:class="{ scrtc_iframe_hide:isLoading, scrtc_iframe_show:!isLoading  }"
        allow="auto"
        :src="scrtc_path"
        frameborder="0"
        ref="scrtc_iframe"
      />
    </div>
  </div>
</template>
<script>
import { APIURL, BASEURL, getCookie } from '../data/config';
import axios from 'axios';

export default {
  name: 'Preview',
  components: {
    // 'Header' : Header
  },
  data () {
    return {
      isLoading: true,
      cntLoading: 0,
      txtLoading: '잠시만 기다려 주십시요.',
      scrtc_iframe: '',
      scrtc_path: '',
      prdctSn: 0,
      USER_SN: 0,
      USER_ID: 0,
      projectData: null
    }
  },
  /** Scratch Library를 해당 View에서만 독립적으로 Import(하단방식도 정상동작) **/
  mounted () {
    // Scratch 라이브러리 기본 Vue 화면 URL 설정
    if (window.VUE_APP_NODE_ENV === 'development') {
      this.scrtc_path = '/scrtc/player';
      //console.log(`[Scrtch::Preview.vue] Dev - scrtch_path : ${this.scrtc_path}`);
    } else {
      this.scrtc_path = '/blk-sc/scrtc/player';
      //console.log(`[Scrtch::Preview.vue] Test&Prod - scrtch_path : ${this.scrtc_path}`);
    }
    this.scrtc_iframe = this.$refs.scrtc_iframe


    // 스크래치 라이브러리 최초 로딩시 시간이 걸리므로 로딩안내창을 띄움 
    // 스크래치 iFrame창 로딩시 원래 로딩관련 Div 숨김처리
    let that = this;
    const iframe = document.getElementById('scrtc_iframe')
    iframe.onload = () => {
      // 로딩화면 걷어 내기
      // that.isLoading = false;
      that.getProjectInfo();
    }

    // 초당 한번씩 로딩 메시지 업데이트
    let v = this;
    var ck = setInterval(function () {
      // 문구 로딩 종료
      if (!v.isLoading) {
        clearInterval(ck);
      }
      // 문구 업데이트
      else {
        ++v.cntLoading;
        let remain = v.cntLoading % 3;
        // console.log('[cntLoading : '+v.cntLoading+' | remain : '+remain)
        switch (remain) {
          case 0: v.txtLoading = '잠시만 기다려 주십시요.'; break;
          case 1: v.txtLoading = '잠시만 기다려 주십시요..'; break;
          case 2: v.txtLoading = '잠시만 기다려 주십시요...'; break;
        }
      }
    }, 1000);
  },
  methods: {
    getProjectInfo () {
      /**
      *  URL 쿼리스트링을 통해 작품공유방 강의실습방을 통해 유입되는지 체크후 스크래치 프로젝트 정보 연동 
      */
      this.sessionOK = true;
      const getCookie = this.getCookie('JSESSIONID');

      var that = this;
      var params = this.$route.params;
      if (!params.id) {
        console.log('스크래치 작품실습값 존재하지 않습니다.');
        alert('요청된 정보가 올바르지 않습니다.');
        return;
      }

      const query = this.$route.query;
      const queryLength = Object.keys(query).length;
      if (queryLength >= 1) {
        const queryPrdctSn = params.id;
        const queryShare = query.share;
        //console.log(`[Preview:mounted] PrdctSn : ${queryPrdctSn} | Share : ${queryShare} | Cookie(JSESSIONID) : ${getCookie}`);

        /**
         *  작품방 > 미리보기 화면
         */
        if (queryShare === 'true') {
          // 쉐어로 들어온 것
          that.sharedPage = true;
          that.prdctSn = queryPrdctSn;        // 작품순번

          // 세션체크
          axios.post(
            APIURL + '/manage/common/session/check',
            { jsession_id: getCookie },
            {
              headers: {
                'Content-Type': 'application/json',
                'LbCookie': document.cookie
              },
            }
          ).then((response) => {
            if (response.status == 200) {
              if (response.data.code === "1000") {
                // if(response.data.user_sn){
                //     that.USER_SN = parseInt(response.data.user_sn);
                //     that.USER_ID = parseInt(response.data.user_id);

                // 이쪽에서 share=true로 들어온 이후
                // 쿠키의 usersn과 makersn 비교해서 같으면 아래
                // 다르면 워크스페이스로 넘김
                axios
                  .get
                  (
                    APIURL + '/manage/scrtc/prctice', {
                    params: {
                      type: 'single',
                      prdct_sn: that.prdctSn,
                      share: that.sharedPage
                    },
                    headers: {
                      'Content-Type': 'application/json',
                      'LbCookie': document.cookie
                    }
                  }
                  )
                  .then(res => {
                    if (res.status === 200) {
                      const { prcticeDetailInfo, code, msg } = res.data;
                      if (code === '1000') {
                        that.projectData = prcticeDetailInfo.prcticePrjct;
                        that.scratchLoad(that.projectData)
                      } else {
                        // 로딩화면 걷어 내기
                        // that.isLoading = false;
                      }
                    }
                  }).catch(e => {
                    console.log('one')
                    alert('해당 정보가 존재하지 않습니다.')
                    this.$router.replace({ name: 'Scratch Practice' });
                  });
              } else {
                console.log('다시 시도해주세요.')
                window.close()
              }
            }
          }).catch(function (error) {
            console.log(error);
            console.log('다시 시도해주세요.')
            window.close();
          });
        }

        /**
         *  강의실습방 > 결과보기
         */
        else if (queryShare === 'false') {

        }
        /**
         *  작품방 or 강의실습방 모두 아닌 형태로 URL이 유입될경우 종료 처리 
         */
        else {
          // share=true가 아니라 이상한 값이 올 경우
          // 반드시 share=true로 와야 하기 때문에 잘못된 경로 접근 처리
          alert('잘못된 접근입니다.')
          window.close();
        }
      }
    },
    scratchLoad (projectData) {
      try {
        let that = this;
        axios
          .get(projectData)
          .then(res => {
            try {
              const sliceSize = 512;
              const b64Data = res.data;
              const byteCharacters = atob(b64Data);
              const byteArrays = [];
              for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
                const slice = byteCharacters.slice(offset, offset + sliceSize);
                const byteNumbers = new Array(slice.length);
                for (let i = 0; i < slice.length; i++) {
                  byteNumbers[i] = slice.charCodeAt(i);
                }
                const byteArray = new Uint8Array(byteNumbers);
                byteArrays.push(byteArray);
              }

              const blob = new Blob(byteArrays);
              const reader = new FileReader();
              reader.readAsArrayBuffer(blob);
              if (reader) {
                reader.onload = () => {
                  that.scrtc_iframe.contentWindow.postMessage({
                    'sender': 'Load',
                    'blobData': reader.result,
                    'host': 'Vue' // origin 구별하기 위한 코드.
                  }, '*');

                  // 로딩화면 걷어 내기
                  that.isLoading = false;
                };
              }
            } catch (e) {
              console.log(`[Preview:scratchLoad] E2 : ${e}`);
              // 로딩화면 걷어 내기
              // that.isLoading = false;
            }
          });
      } catch (e) {
        console.log(`[Preview:scratchLoad] E1 : ${e}`);
        // 로딩화면 걷어 내기
        // this.isLoading = false;
      }
    },
    getCookie (name) {  /// Retrieve cookie function
      var match = document.cookie.match(new RegExp(name + '=([^;]+)'));
      if (match) return match[1];
      return
    },
  }
}
</script>

<style lang="scss">
.preview {
  position: absolute;
  width: 100%;
  height: calc(100% - 50px);
}
.scrtc_main {
  position: relative;
  width: 100%;
  height: 100%;
  //overflow: auto;
  // background-color: #5096f5;
  //background-color: red;
}
.scrtc_loading_show {
  width: 100%;
  height: 100%;
  // display: block;
  background-color: #5096f5;
  // background-color: red;
  display: flex;
  align-items: center;
  justify-content: center;

  .loading_text {
    color: #fff;
    // background-color: #5096f5;
    font-weight: 900;
    font-size: 25px;
    font-family: "Noto Sans KR";
    vertical-align: middle;
  }
}
.scrtc_loading_hide {
  width: 0%;
  height: 0%;
  display: none;
  background-color: #5096f5;
}
.scrtc_iframe {
  width: 100%;
  height: 100%;
  display: block;
}
.scrtc_iframe_hide {
  width: 100%;
  height: 100%;
  display: none;
}
.scrtc_iframe_show {
  width: 100%;
  height: 100%;
  display: block;
}
</style>

